// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"2221":"19a4071c","3354":"5dba74f3"}[chunkId] + ".chunk.css";
};